/* card-hover-gallery.js — materialize deferred product-card gallery images, and drive the
   index dots on the phone swipe track. The extra gallery images ship with empty src +
   data-src/data-srcset so they cost nothing until the visitor shows interest. Two triggers,
   because a phone has no hover: first pointer entry (desktop) and first scroll of the track
   (touch — pointerover does fire on tap, but a swipe that starts as a scroll should not
   depend on it). Script tag repeats per card (Liquid can't dedupe across block renders);
   this guards against re-running. */
(function () {
  if (window.__cardHoverGallery) return;
  window.__cardHoverGallery = true;

  function hydrate(media) {
    if (!media || media.hasAttribute('data-hydrated')) return;
    media.setAttribute('data-hydrated', '');
    media.querySelectorAll('img[data-src]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  document.addEventListener('pointerover', function (e) {
    hydrate(e.target.closest('.product-image--hover:not([data-hydrated])'));
  });

  /* Capture phase: scroll does not bubble, so a delegated listener only sees it on the way
     down. One listener for every card on the page. */
  document.addEventListener(
    'scroll',
    function (e) {
      var track = e.target;
      if (!track.classList || !track.classList.contains('product-image__track')) return;
      var media = track.parentElement;
      hydrate(media);
      var dots = media.querySelectorAll('.product-image__dot');
      if (!dots.length || !track.clientWidth) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (dot, j) {
        dot.classList.toggle('is-active', j === i);
      });
    },
    true
  );
})();
